module.exports = __webpack_public_path__ + "static/media/Thomas E. Dewey - 1948.95cda66f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Thomas E. Dewey - 1948.jpg
// module id = 553
// module chunks = 0